<template>
  <div class="pc_container app-main-content">
    <leftSlider :list="leftList" :check="2"></leftSlider>
    <div class="app-main-content-section bgfff">
      <div class="page_title">系统管理员</div>
      <div class="flex flex_between mb24">
        <div>
          <!-- <el-select v-model="SlectRegion" filterable placeholder="请选择岗位" class="mr24">
            <el-option v-for="item in listOption" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select> -->
          <el-input placeholder="请输入" prefix-icon="el-icon-search" v-model="keyword"
            class="select-inpw mr16"></el-input>
        </div>
        <div class="flex flex_items">
          <div class=" page_main_bg cf pointer handle-btn mr16" @click="addNew" v-if="role('manage.system.manage.add')">
            <img src="@/assets/index/ad-icon.png" alt="" class="mini-icon" style="margin-right: 4px;">
            <span class="l1">添加</span>
          </div>
          <div class=" page_main_bg cf pointer handle-btn mr16" @click="exDiaVisibleShow"
            v-if="role('manage.system.manage.import')">
            <img src="@/assets/index/ex-icon.png" alt="" class="mini-icon" style="margin-right: 4px;">
            <span class="l1">导入</span>
          </div>
          <!-- <a :href="exportUrl" v-if="role('manage.member.export')">
            <div class=" page_main_bg cf pointer handle-btn mr16">
              <img src="@/assets/index/up-icon.png" alt="" class="mini-icon" style="margin-right: 4px;">
              <span class="l1">导出</span>
            </div>
          </a> -->
          <!-- <div class=" main_bg_red cf pointer handle-btn" v-if="role('manage.member.del')" @click="delM">
            <img src="@/assets/index/del-2.png" alt="" class="mini-icon" style="margin-right: 4px;">
            <span class="l1">批量删除</span>
          </div> -->
        </div>
      </div>
      <div>
        <!-- @selection-change="handleSelectionChange" -->
        <el-table :data="list" style="width: 100%" :header-cell-style="{
          background: '#F3F3F3',
          color: '#1F3349',
          fontSize: '15px',
          fontWeight: 'normal',
        }" :cell-style="{ fontSize: '15px', color: '#666666' }">
          <!-- :index="indexMethod" type="index"-->
          <!-- <el-table-column prop="id" label="序号" align="left" width="110">
          </el-table-column> -->
          <!-- <el-table-column type="selection" width="50">
          </el-table-column> -->
          <el-table-column prop="id" label="ID">
          </el-table-column>
          <el-table-column prop="roleName" label="角色">
          </el-table-column>
          <el-table-column prop="account" label="账号">
          </el-table-column>
          <el-table-column prop="nickname" label="名称">
          </el-table-column>
          <el-table-column prop="phone" label="电话">
          </el-table-column>
          <!-- <el-table-column prop="code" label="性别" width="80">
            <template slot-scope="scope">
              {{ scope.row.sex == 0 ? '女' : '男' }}
            </template>
</el-table-column> -->
          <el-table-column prop="address" label="区域" width="150">
          </el-table-column>
          <!-- <el-table-column prop="storeName" label="所属门店" width="100">
          </el-table-column> -->

          <!-- 操作 -->
          <el-table-column fixed="right" align="left" label="操作" width="150">
            <template slot-scope="scope">
              <div class="flex flex_items table-list">
                <div @click="handleClick(scope.row)" class="main_color pointer page-handle-btn"
                  v-if="role('manage.system.manage.edit')">
                  编辑
                </div>
                <div class="main_color pointer page-handle-btn" @click="del(scope.row)"
                  v-if="role('manage.system.manage.del')">
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
          <div slot="empty" style="text-align: center;width:100%">
            暂无数据
          </div>
        </el-table>

        <div class="flex flex_end pagination" v-if="total > 10">
          <el-pagination background layout="prev, pager, next,sizes,jumper" :total="total"
            @current-change="currentChange" :current-page="currentPage" :page-size="pageSize" @size-change="pageSizeC">
          </el-pagination>
        </div>
      </div>

      <!-- 添加-->
      <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true"
        :title="!handleId ? '添加' : '编辑'" :visible.sync="dialogVisible" width="600px">
        <div class="flex f14 mb24">
          <div style="width:70px;margin-top:10px" class="txt_right mr10"> 选择角色</div>
          <!-- filterable -->
          <div>
            <el-select v-model="roleName" placeholder="请选择" class="flex1" @change="rolechange($event)">
              <el-option v-for="item in options" :key="item.id" :label="item.display_name" :value="item.id">
              </el-option>
            </el-select>
            <div class="f12 mt10" style="color: #95979b;">
              管理：全部权限<br>
              主管：部分权限，主要可查看自己管辖区域的自检和培训考试结果<br>
              审核主管：仅审核板块权限<br>
              审核：仅被分配的问卷审核权限
            </div>
          </div>
        </div>
        <div class="flex flex_items f14 mb24">
          <div style="width:70px" class="txt_right mr10"><span class="color-red">*</span> 名称</div>
          <el-input placeholder="请输入" v-model="nickname" class="flex1"></el-input>
        </div>
        <!-- <div class="flex flex_items f14 mb24">
          <div style="width:70px" class="txt_right mr10">性别</div>
          <div>
            <el-radio v-model="sex" label="0">女</el-radio>
            <el-radio v-model="sex" label="1">男</el-radio>
          </div>
        </div> -->
        <div class="flex flex_items f14 mb24" v-if="regionsCheck">
          <div style="width:70px" class="txt_right mr10"> 选择区域</div>
          <!-- filterable -->
          <el-select v-model="regions" multiple placeholder="请选择" class="flex1">
            <el-option v-for="item in regionsList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>

        <div class="flex flex_items f14 mb24">
          <div style="width:70px" class="txt_right mr10">账号</div>
          <el-input placeholder="请填写" v-model="account" class="flex1"></el-input>
        </div>
        <div class="flex flex_items f14 mb24">
          <div style="width:70px" class="txt_right mr10"> 手机号</div>
          <el-input placeholder="请输入" v-model="phone" class="flex1" type="number"></el-input>
        </div>
        <div class="flex flex_items f14">
          <div style="width:70px" class="txt_right mr10">密码</div>
          <el-input placeholder="请填写" v-model="password" class="flex1" type="password"></el-input>
        </div>

        <div slot="footer" class="dialog-footer flex flex_items f14 flex_end">
          <div class="sub_btn page_main_bg cf" @click="handleSure">立即提交</div>
        </div>
      </el-dialog>

    </div>

    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true" :title="uploadFileTitle"
      :visible.sync="exDiaVisible" width="30%">
      <UploadFile type="9" @uploadFile="uploadFile" ref="UploadFile"></UploadFile>
    </el-dialog>



  </div>
</template>
<script>
import leftSlider from '@/components/leftSlider/leftSlider'
import leftList from './utils/list'
import { PUBLICURL } from '@/utils/index'
import { getRoleArr, pageSize } from '@/utils/tool';
import { phoneCheck } from '@/utils/public'
import UploadFile from '@/components/uploadFile.vue';
import { exportUrl } from '@/utils/downloadUrl'
import bread from '@/utils/breadList'

export default {
  data() {
    return {
      list: [],
      PUBLICURL: PUBLICURL,
      check: 0,
      leftList: leftList,
      dialogVisible: false,
      total: 0,
      currentPage: 1,
      pageSize: pageSize,
      keyword: '',
      role: getRoleArr,
      choseArr: [],
      nickname: '',
      roleName: '',
      phone: '',
      password: '',
      account: '',
      handleId: '',
      drawSelect: [],
      options: [],
      optionstaues: [],
      listOption: [],
      address: '',
      SlectRegion: '',

      addRegionPop: false,
      area: '',
      sex: '',
      uploadFileTitle: '导入',
      exportUrl: '',
      exDiaVisible: false,
      associatedArea: [],//需要绑定区域的角色
      regionsList: [],
      regionsCheck: false,
      regions: [],
    };
  },
  components: { leftSlider, UploadFile },
  watch: {
    keyword() {
      this.currentPage = 1;
      this.getList()
    },
    SlectRegion() {
      this.currentPage = 1;
      this.getList()
    }
  },
  methods: {
    rolechange(e) {
      let name = this.options.filter(r => r.id == e)[0].name;
      console.log(name);
      if (this.associatedArea.indexOf(name) >= 0) {
        this.regionsCheck = true;
      } else {
        this.regionsCheck = false;
      }

    },
    exDiaVisibleShow() {
      this.exDiaVisible = true;
      this.uploadFileTitle = '导入'
      this.$nextTick(r => {
        this.$refs.UploadFile.resetData()
      })
    },
    uploadFile() {
      this.uploadFileTitle = '导入结果'
      this.currentChange = 1;
      this.getList()
    },
    indexMethod(e) {
      return (e + 1) + this.pageSize * (this.currentPage - 1)
    },
    handleSure() {
      if (this.roleName == '') return this.$message.error('请选择角色');
      if (this.nickname == '') return this.$message.error('请输入姓名');
      if (this.phone == '' && this.account == '') return this.$message.error('手机号账号至少填写一个');
      if (this.phone && !phoneCheck(this.phone)) return this.$message.error('手机号有误');
      if (!this.handleId && this.account && this.password == '') return this.$message.error('请输入密码');
      let obj = {
        nickname: this.nickname,
        // address: this.address,
        phone: this.phone,
        account: this.account,
        password: this.password,
        role: this.roleName
      }
      if (this.regionsCheck) {
        obj.regions = this.regions;
      }
      let url = this.handleId ? `/api/manage/system/manage/edit/` + this.handleId : `/api/manage/system/manage/add`
      this.api.postUrl(url, obj, {}).then(res => {
        if (res.code == 200) {
          this.$message.success(this.handleId ? '编辑成功' : '添加成功');
          this.dialogVisible = false;
          this.currentPage = 1;
          this.getList()
        }
      })
    },
    addRegion() {
      this.addRegionPop = true;
    },
    addNew() {
      this.handleId = '';
      this.account = '';
      // this.sex = '0';
      this.address = '';
      this.roleName = '';
      this.phone = '';
      this.nickname = '';
      this.password = '';
      this.dialogVisible = true;
      this.regions = [];
      this.regionsCheck = false;
      // this.api.member_add_get().then(res => {
      //   this.options = res.data.job;
      //   this.optionstaues = res.data.store;
      //   this.dialogVisible = true;
      // })
    },
    getList() {
      this.api.getUrl(`/api/manage/system/manage/list`, {
        size: this.pageSize,
        page: this.currentPage,
        keyword: this.keyword
      }, {})
        .then((res) => {
          this.list = res.data.list;
          this.total = res.data.meta.total;
          this.perPage = res.data.meta.perPage;
        });
    },
    currentChange(e) {
      this.currentPage = e
      this.getList();
    },
    pageSizeC(e) {
      this.pageSize = e;
      this.getList()
    },
    handleClick(e) {
      this.api.getUrl(`/api/manage/system/manage/edit/${e.id}`, {}, { loading: true }).then(res => {
        console.log(res);
        let d = res.data.data;
        this.handleId = e.id;
        this.roleName = this.options.filter(s => s.display_name == e.roleName)[0].id;
        this.phone = d.phone;
        this.nickname = d.nickname;
        this.password = d.password;
        this.account = d.account;
        console.log(this.associatedArea.indexOf(d.role));

        if (this.associatedArea.indexOf(d.role) >= 0) {
          this.regionsCheck = true;
        } else {
          this.regionsCheck = false;
        }
        this.regions = d.regions ? d.regions : []

        // this.roleName = e.account;
        this.dialogVisible = true;
      })
      // this.api.member_edit_get({}, {}, '/' + this.handleId).then(res => {
      // let e = res.data.member;
      // this.options = res.data.job;
      // this.optionstaues = res.data.store;
      // this.store = e.store;
      // this.sex = e.sex.toString();
      // this.job = e.job ? e.job : '';
      // this.address = e.address;
      // this.code = e.code;

      // })
    },
    delM() {
      if (this.choseArr.length == 0) return this.$message.error('请选择您要删除的数据');
      this.$confirm('确认删除选中数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [];
        this.choseArr.map(r => {
          ids.push(r.id)
        })
        this.delAjax(ids)
      }).catch(() => { });
    },

    del(d) {
      // console.log(d);
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delAjax([d.id])
      }).catch(() => { });
    },
    delAjax(item) {
      this.api
        .store_del(
          { ids: item },
          {
            loading: true,
          }
        )
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.currentPage = 1;
            this.getList();
          }
        });
    },
    handleSelectionChangeDarw(e) {
      this.drawSelect = e
    },
    getInfo() {
      this.api.getUrl(`/api/manage/system/manage/add`, {}, {}).then(res => {
        this.options = res.data.role;
        this.associatedArea = res.data.associatedArea;
        this.regionsList = res.data.regions;
      })
    }
  },
  created() {
    this.getList()
    this.getInfo()
    this.exportUrl = exportUrl(1)
    this.$store.dispatch('app/setBreadListMutations', bread(4, '', '系统管理员'))
    this.leftList = leftList;

    // this.addNew()
  },
};
</script>
<style scoped>
.list-items {
  width: 266px;
  height: 150px;
  background: #F5F7FA;
  border-radius: 8px 8px 8px 8px;
  box-sizing: border-box;
}

.icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}

.page_title {
  margin-bottom: 24px;
}

.label.label1 {
  color: #67C23A;
  background: rgba(103, 194, 58, .29);
}

.label {
  padding: 2px 6px;
  background: rgba(64, 158, 255, .29);
  border-radius: 4px;
}

.table-list .page-handle-btn:first-child {
  padding-left: 0;
}
</style>
<style>
.el-progress__text {
  font-size: 13px !important;
}
</style>